// ---------------------------------------------------------------------------
// Browser-runtime helpers for Datadog CSP violation handling.
//
// Used in each app's datadogRum / datadogLogs beforeSend callbacks to detect
// CSP violation messages and downgrade them from error → warn.
// ---------------------------------------------------------------------------

/**
 * Detect CSP violation messages from the browser.
 *
 * The Datadog RUM SDK captures `securitypolicyviolation` DOM events and
 * forwards them through the beforeSend callbacks.  Browser-generated CSP
 * messages use formats like:
 *   Chrome:  "Refused to load the script '…' because it violates …
 *             Content Security Policy directive: …"
 *   Firefox: "Content-Security-Policy: …"
 *   Safari:  "Refused to load … because it does not appear in the
 *             content-security-policy …"
 */
export const isCspViolationReport = (
  message: string | undefined
): boolean => {
  if (!message) return false;
  const lower = message.toLowerCase();
  return (
    lower.startsWith("csp_violation:") ||
    lower.includes("content security policy") ||
    lower.includes("content-security-policy")
  );
};
